import { repeat } from 'ramda';

export const createRange = (start, end) =>
  [...Array(end - start)].map((_val, i) => i + start);

export const repeatArray = (times, arr) =>
  repeat(arr, times).flat();
